export const getTokenFromStorage = () => {
  if (!window.localStorage) {
    console.error("LocalStorage not defined");
  }
  return localStorage.getItem("andytown__token2");
};
